import type { StateCreator } from 'zustand';
import { infermedicaApi } from '@/API/modules/infermedicaApi';
import type { IManualIntakeSlice } from './types';

const initialState: Pick<
  IManualIntakeSlice,
  'manualIntakeLoading' | 'specialties' | 'symptoms'
> = {
  manualIntakeLoading: false,
  specialties: null,
  symptoms: null,
};

export const manualIntakeSlice: StateCreator<
  IManualIntakeSlice,
  [],
  [],
  IManualIntakeSlice
> = (set) => ({
  ...initialState,

  clearManualIntake: () => set(initialState),

  getSpecialties: async () => {
    set({ manualIntakeLoading: true });
    try {
      const { data } = await infermedicaApi.getSpecialties();
      set({ specialties: data.data });
    } finally {
      set({ manualIntakeLoading: false });
    }
  },

  getSymptoms: async () => {
    set({ manualIntakeLoading: true });
    try {
      const { data } = await infermedicaApi.getSymptoms();
      set({ symptoms: data.data });
    } finally {
      set({ manualIntakeLoading: false });
    }
  },
});
